export default "__VITE_ASSET__B5TO_kXF__"